import { useState, useEffect } from "react";
import { findTransferReelList, loadSONumberListReelTransfer } from "../services/storageLocationService";

const useGetSONumberListForReelTransfer = (editID) => {
    const [salesOrderNumber, setSalesOrderNumber] = useState([]);
    const [selectedSalesOrderNumber, setSelectedSalesOrderNumber] = useState([]);
    const [selectedSalesOrderNumberID, setSelectedSalesOrderNumberID] = useState([]);
    const [isMaterialCodeDataLoaded, setIsMaterialCodeDataLoaded] = useState(false);
    const [ddloading, setddLoading] = useState(false);
    const [selectedWidth, setSelectedWidth] = useState(0);
    const [selectedLength, setSelectedLength] = useState(0);
    const [selectedLineNumber, setSelectedLineNumber] = useState(0);
    const [selectedQuality, setSelectedQuality] = useState('');
    const [selectedGSM, setSelectedGSM] = useState('');
    const [transferReelList, setTransferReelList] = useState([]);

    // Fetch sales order numbers
    const fetchRequestIndentNumber = async (selectedID) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plant_id: 1, p_mode: 0, p_quality: '', p_gsm: '', };
        setddLoading(true); // Show loader
        try {
            const data = await loadSONumberListReelTransfer(para);
            if (data && data.length > 0) {
                setSalesOrderNumber(data);
                const initialDepartment = data.find((dept) => dept.so_number === selectedID);
                if (initialDepartment?.length > 0) {
                    setSelectedSalesOrderNumber(initialDepartment);
                    setIsMaterialCodeDataLoaded(true); // Update state after data is loaded
                }


            }
        } catch (error) {
            console.error("Error fetching sales order numbers:", error);
        }
        finally {
            setddLoading(false); // Hide loader after fetching
        }
    };

    const fetchTransferOrderToList = async (Quality, GSM) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plant_id: 1, p_mode: 1, p_quality: Quality, p_gsm: GSM, };
        setddLoading(true); // Show loader
        try {
            const data = await loadSONumberListReelTransfer(para);
            if (data && data.length > 0) {
                setSalesOrderNumber(data);
            }
        } catch (error) {
            console.error("Error fetching sales order numbers:", error);
        }
        finally {
            setddLoading(false); // Hide loader after fetching
        }
    }

    // Load sales order numbers when the component mounts
    useEffect(() => {
        if (!isMaterialCodeDataLoaded && editID === 0) {
            fetchRequestIndentNumber();
        }
    }, [isMaterialCodeDataLoaded, editID]);

    // Function to update selected sales order number
    const loadSalesOrderNumberByID = (selectedID, lineNumber, width, length, quality, gsm) => {
        setSelectedSalesOrderNumber(selectedID);
        setSelectedWidth(width);
        setSelectedLength(length);
        setSelectedLineNumber(lineNumber);
        setSelectedQuality(quality);
        setSelectedGSM(gsm);
    };

    const refreshSelectionDetail = async () => {
        setSelectedSalesOrderNumber([]);
        setSelectedWidth(0);
        setSelectedLength(0);
        setSelectedLineNumber(0);
        setSelectedQuality('');
        setSelectedGSM('');
    }

    const fetchTransferedReelList = async () => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plant_id: 1 };
        setddLoading(true); // Show loader
        try {
            const data = await findTransferReelList(para);
            if (data && data.length > 0) {
                setTransferReelList(data);
            }
        } catch (error) {
            console.error("Error fetching sales order numbers:", error);
        }
        finally {
            setddLoading(false); // Hide loader after fetching
        }
    }

    return {
        salesOrderNumber,
        selectedSalesOrderNumber,
        selectedSalesOrderNumberID,
        selectedWidth,
        selectedLength,
        selectedLineNumber,
        selectedQuality,
        selectedGSM,
        setSalesOrderNumber,
        setSelectedSalesOrderNumber,
        setSelectedSalesOrderNumberID,
        loadSalesOrderNumberByID,
        ddloading,
        setddLoading,
        setSelectedWidth,
        setSelectedLength,
        setSelectedLineNumber,
        setSelectedQuality,
        setSelectedGSM,
        refreshSelectionDetail,
        fetchTransferOrderToList,
        fetchTransferedReelList,
        transferReelList,
        setTransferReelList,
    };
};

export default useGetSONumberListForReelTransfer;
